import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
  Legend, ResponsiveContainer
} from 'recharts';
import { Button } from 'react-bootstrap';
import { colors } from '../../brand-colors';

/**
 * Funnel Metrics Chart - Line showing Sales, Leads, Tripwires over time
 * Placeholder until PostHog analytics integration is configured
 */
function FunnelMetricsChart({ data, onConnect }) {
  // Check if analytics is connected
  if (!data || !data.connected) {
    return (
      <div style={styles.placeholder}>
        <div style={styles.icon}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke={colors.teal}>
            <path d="M22 12h-4l-3 9L9 3l-3 9H2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <p style={styles.title}>Connect Analytics</p>
        <p style={styles.subtitle}>
          {data?.message || 'Connect PostHog to see funnel metrics'}
        </p>
        <Button
          variant="outline-info"
          size="sm"
          onClick={onConnect}
          style={styles.button}
        >
          Configure Integration
        </Button>
      </div>
    );
  }

  // When connected, show actual data
  const chartData = data.data || [];
  const isSampleData = data.is_sample === true;

  if (chartData.length === 0) {
    return (
      <div style={styles.placeholder}>
        <p>Waiting for data...</p>
        <small>Analytics will sync shortly</small>
      </div>
    );
  }

  return (
    <div style={{ position: 'relative' }}>
      {isSampleData && (
        <div style={styles.sampleBadge}>
          SAMPLE DATA
        </div>
      )}
      <ResponsiveContainer width="100%" height={250}>
      <LineChart
        data={chartData}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
        <XAxis
          dataKey="date"
          tick={{ fill: colors.grey, fontSize: 11 }}
        />
        <YAxis
          tick={{ fill: colors.grey, fontSize: 12 }}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: '#fff',
            border: '1px solid #e0e0e0',
            color: colors.greyDarkest
          }}
        />
        <Legend />
        <Line
          type="monotone"
          dataKey="leads"
          name="Leads"
          stroke={colors.tealMid}
          strokeWidth={2}
          dot={{ fill: colors.tealMid, r: 4 }}
        />
        <Line
          type="monotone"
          dataKey="tripwires"
          name="Tripwires"
          stroke={colors.teal}
          strokeWidth={2}
          dot={{ fill: colors.teal, r: 4 }}
        />
        <Line
          type="monotone"
          dataKey="sales"
          name="Sales"
          stroke={colors.tealDark}
          strokeWidth={2}
          dot={{ fill: colors.tealDark, r: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
    </div>
  );
}

const styles = {
  sampleBadge: {
    position: 'absolute',
    top: 5,
    right: 10,
    backgroundColor: '#dc3545',
    color: '#fff',
    padding: '4px 10px',
    borderRadius: 4,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.5px',
    zIndex: 10
  },
  placeholder: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 250,
    color: colors.greyMid,
    textAlign: 'center',
    padding: 20
  },
  icon: {
    marginBottom: 15
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    color: colors.greyDarkest,
    marginBottom: 5
  },
  subtitle: {
    fontSize: 13,
    color: colors.greyMid,
    marginBottom: 15,
    maxWidth: 280
  },
  button: {
    borderColor: colors.teal,
    color: colors.tealDark
  }
};

export default FunnelMetricsChart;
